import React, { useState, useContext, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { dashboardControlActions } from '../../../../dashboard/actions';
import { FirebaseContext2 } from '../../../../../firebase';
import { List } from '../../../../../components/List/TabList';
import { Info, ActivityData, HistoryData } from '../../../components/Tabs';
import { energyActions } from '../../../../energy/actions';
import moment from 'moment';
import { roomActivitiesHistories } from '../../../../../api/services';
import { API_CONSTANTS } from '../../../../../api';
import { iotControlServices } from '../../../../../api/services';

const SmartTVControl = (props) => {
  const dispatch = useDispatch();
  const isControlIot = useSelector((state) => state.dashboard.isControlIot);
  const currentRoomNo = useSelector((state) => state.dashboard.currentRoomNo);

  const InitPlotData = useSelector((state) => state.historyEnergy.hist);
  const dropdown = useSelector((state) => state.hotel.dropdown);

  const getDevices = useSelector((state) => state.hotel.allDevices);
  const devices = getDevices ? getDevices.devices : null;
  const [plotHistData, setPlotHistData] = useState([]);
  const [tmpHist, settmpHist] = useState(null);

  const [currentTab, setCurrentTab] = useState('control');

  const timeoutid = useRef();

  const onCloseModal = (event) => {
    event.preventDefault();
    dispatch(energyActions.clearHistoryData());
    dispatch(dashboardControlActions.showIotModal(false));
  };

  const d = new Date();

  function GetMonth() {
    // eslint-disable-next-line
    let month = new Array();
    month[0] = 'Jan';
    month[1] = 'Feb';
    month[2] = 'Mar';
    month[3] = 'Apr';
    month[4] = 'May';
    month[5] = 'Jun';
    month[6] = 'Jul';
    month[7] = 'Aug';
    month[8] = 'Sep';
    month[9] = 'Oct';
    month[10] = 'Nov';
    month[11] = 'Dec';

    return month[d.getMonth()];
  }

  const firebase = useContext(FirebaseContext2);

  //##-------------------Switch--------------------------------
  const [openTV, setOpenTV] = useState(null);

  const [status, setStatus] = useState({
    smart_tv_switch: {
      status: null,
      time: null,
    },
  });

  const reverseText = (text) => {
    return text.split(':').reverse().join(':');
  };

  async function fetchData(firebase, currentRoomNo, didMounted) {
    let fbpath =
      API_CONSTANTS.FIREBASE_MINTEL_REAL_TIME_PATH +
      'room_' +
      currentRoomNo +
      '/iot_devices/smart_tv/remotec/tv_remote';

    if (didMounted) {
      console.log('Smart TV did mounted');
      await firebase.db.ref(fbpath).off('value');
    } else {
      await firebase.db.ref(fbpath).on('value', function (snap) {
        let capt = snap.val();
        if (capt !== null || undefined) {
          setStatus({
            smart_tv_switch: {
              status: capt.commands,
              time: capt.timestamp,
            },
          });
        }
      });
    }
  }

  async function triggerAPI(currentStatus, swLocation, currentRoomNo) {
    //##-------------------------Payload-----------------------------------
    const payload = {
      topic: 'devicecontrol',
      action: {
        [currentRoomNo]: {
          [swLocation]: {
            command: {
              state: currentStatus,
            },
          },
        },
      },
      RequestId: '12345',
    };

    console.log(payload.message, payload.device);
    iotControlServices.postIotApi(payload);
  }
  async function histData(dev_id, nick_name) {
    try {
      let results = await roomActivitiesHistories.getActivitiesHistories(
        currentRoomNo,
        reverseText(dev_id),
        dropdown,
        nick_name,
        false,
        props.startDate,
        props.stopDate
      );
      if (results) {
        if (results['errors'] !== undefined) {
          // [DEBUG]
          let errorMsgDevice = results['errors'];
          // alert(errorMsg);
          console.error(errorMsgDevice);

          return null;
        } else {
          if (results.data) {
            let mapDataActivity = results.data.results;

            return mapDataActivity;
          } else {
            return null;
          }
        }
      } else {
        return null;
      }
    } catch (error) {
      return null;
    }
  }

  //##-------------------sync data from firebase only-----------------
  useEffect(() => {
    fetchData(firebase, currentRoomNo, false);
    return () => {
      dispatch(energyActions.clearHistoryData());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (tmpHist !== null) {
      let tmp1 = [];
      tmpHist.forEach((item) => {
        if (item.state !== null && item.timestamp !== null) {
          tmp1.push([Number(moment(item.timestamp).format('x')), item.state === 'on' ? 1 : 0]);
        }
        return setPlotHistData(tmp1);
      });
    }
  }, [tmpHist]);

  useEffect(() => {
    initSwitch(status.smart_tv_switch.status);
  }, [status]);

  //##-------------------update current status only-----------------
  useEffect(() => {
    clearTimeout(timeoutid.current);

    devices.forEach((element) => {
      if (element['device_name'] === 'fan') {
        try {
          histData(element.device_id, 'fan').then((results) => {
            return settmpHist(results);
          });
        } catch {
          console.log('Fetch error');
        }
      }
    });

    let tmp = [];
    timeoutid.current = setTimeout(() => {
      // tmp.push(Number(moment(corridor.time).format('x')), corridor.state === 'on' ? 1 : 0);
      if (status.smart_tv_switch.time !== null && status.smart_tv_switch.status !== null) {
        switch (Number(dropdown)) {
          case 0:
            tmp.push(
              Number(moment(status.smart_tv_switch.time).format('x')),
              status.smart_tv_switch.status === 'on' ? 1 : 0
            );
            console.log('TV');
            break;
          default:
            console.log('default');
            break;
        }

        dispatch(
          energyActions.mintelHistoryData({
            hist: {
              front_switch: [],
              back_switch: [],
              ac: [],
              fan: [],
              fridge: { state: [], power: [] },
              smart_meter: { energy: [], power: [] },
              smart_tv: tmp,
            },
          })
        );
      }
    }, 2000);

    return () => clearTimeout(timeoutid.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dropdown, props.startDate, props.stopDate, status]);

  //##-----------------Sync status from firebase------------------
  const initSwitch = (status1) => {
    if (status1 === 'on') {
      setOpenTV(true);
    } else {
      setOpenTV(false);
    }
  };

  const onClick1 = (event) => {
    clearTimeout(timeoutid.current);
    event.preventDefault();
    setOpenTV((prev) => !prev);
    const location = 'Smart TV';

    if (openTV !== null) {
      timeoutid.current = setTimeout(
        () => triggerAPI(!openTV ? 'tv_on' : 'tv_off', location, currentRoomNo),
        700
      );
    }
    return () => clearTimeout(timeoutid.current);
  };

  const imagesPath = {
    open: '/assets/images/devices/icon-tv-open.png',
    close: '/assets/images/devices/icon-tv-close.png',
  };

  //##-------------------Tab menu------------------------------
  const onClickTabMenu = (event, tabName) => {
    event.preventDefault();
    setCurrentTab(tabName);
  };

  const image_link =
    'https://www.tcl.com/content/dam/tcl-dam/product/tv-product/s-series/s65a/site/pc/product-image/S65A-Front-global.png';

  const hist_plot = {
    series: [
      {
        name: 'Switch',
        // data: plotHistData.concat(Main_mdb.plot),
        // data: InitPlotData.front_switch.concat(TmpData),
        // name: 'Switch',
        data:
          plotHistData !== undefined && plotHistData !== null && InitPlotData.smart_tv !== undefined
            ? plotHistData.concat(InitPlotData.smart_tv)
            : [],
        // data: dataPlotRealTime[0] !== NaN ? dataPlotRealTime : [],
      },
    ],
    options: {
      annotations: {
        yaxis: [
          {
            // x: 0,
            y: 1,
            // borderColor: '#00E396',
            label: {
              // borderColor: '#00E396',
              style: {
                color: '#fff',
                background: '#00E396',
              },
              text: 'Light ON',
            },
          },
          {
            // x: 0,
            y: 0,
            // borderColor: '#e30062',
            label: {
              // borderColor: '#e30062',
              style: {
                color: '#fff',
                background: '#e30062',
              },
              text: 'Light OFF',
            },
          },
        ],
      },
      // chart: {
      //   id: 'area-datetime',
      //   type: 'area',
      //   height: 350,
      //   zoom: {
      //     autoScaleYaxis: true,
      //   },
      // },
      dataLabels: {
        enabled: false,
      },
      markers: {
        size: 0,
        // style: 'hollow',
      },
      stroke: {
        curve: 'stepline',
        width: 2,
      },
      xaxis: {
        type: 'datetime',
        min: new Date(`${d.getDate()} ${GetMonth()} ${d.getFullYear()} 00:00:00`).getTime(),
        max: new Date(`${d.getDate()} ${GetMonth()} ${d.getFullYear()} 23:59:59`).getTime(),
        labels: {
          datetimeUTC: false,
        },
      },

      yaxis: {
        max: 1.5,
        show: false,
      },
      title: {
        text: 'Activity in 24 hrs',
        align: 'left',
      },
      tooltip: {
        x: {
          format: 'dd.MM.yyyy HH:mm',
        },
      },
    },
  };

  return (
    <div className="modal is-active" id="iot-modal">
      <div
        className="modal-background"
        onClick={(e) => onCloseModal(e)}
        id="modal-background-IOT"
      ></div>
      <div className="modal-card">
        <header className="modal-card-head" style={{ margin: 0, padding: '0px 20px 0px 20px' }}>
          <div className="room-name" style={{ width: '100%' }}>
            <p className="modal-card-title" style={{ marginTop: '1rem' }}>
              Smart TV
            </p>
          </div>
        </header>
        <section
          className="modal-card-body"
          style={{
            maxHeight: '100%',
            height: '600px',
          }}
        >
          {isControlIot && (
            <div id="ucount-w">
              <div id="modal-menu">
                <nav className="panel" style={{ boxShadow: 'none' }}>
                  <div className="tabs is-toggle is-fullwidth" style={{ marginBottom: '10px' }}>
                    <ul style={{ margin: '15px' }}>
                      <List
                        isSelected={currentTab === 'control'}
                        onClick={(e) => onClickTabMenu(e, 'control')}
                      >
                        CONTROL
                      </List>
                      <List
                        isSelected={currentTab === 'info'}
                        onClick={(e) => onClickTabMenu(e, 'info')}
                      >
                        INFO
                      </List>
                      <List
                        isSelected={currentTab === 'activity'}
                        onClick={(e) => onClickTabMenu(e, 'activity')}
                      >
                        ACTIVITY
                      </List>
                      <List
                        isSelected={currentTab === 'history'}
                        onClick={(e) => onClickTabMenu(e, 'history')}
                      >
                        HISTORY
                      </List>
                    </ul>
                  </div>
                  {/* Control tab */}
                  {currentTab === 'control' && (
                    <div className="iot-element" id="iot-control-tv">
                      <div className="columns">
                        <div
                          className="column"
                          style={{
                            // border: '1px #aaa solid',
                            borderRadius: '5px',
                            margin: '5px',
                          }}
                        >
                          <div className="column">
                            <img
                              alt="tv-icon"
                              id="icon-tv-close"
                              style={{
                                width: '200px',
                                height: 'auto',
                                display: 'block',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                                marginTop: '7%',
                                cursor: 'pointer',
                              }}
                              src={openTV ? imagesPath.open : imagesPath.close}
                              onClick={(e) => onClick1(e)}
                            />
                          </div>
                          <div className="column">
                            <button
                              className={
                                openTV
                                  ? 'button is-success device-controller'
                                  : 'button is-unsuccess device-controller'
                              }
                              // fbconnect='{"fbpath": "/hotel/mintel/building main/floor 1/room 108/tasmota_b38c3e/data/gang 2", "type": "toggle", "deviceid": "78:0F:77:D6:44:01", "icons":["icon-tv-close","icon-tv-open"]}'
                              style={{
                                width: '100px',
                                height: 'auto',
                                display: 'block',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                              }}
                              onClick={(e) => onClick1(e)}
                            >
                              {/* {status.smart_tv_switch.status === 'on' ? 'ON' : 'OFF'} */}
                              {openTV ? 'ON' : 'OFF'}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {currentTab === 'info' && (
                    <Info image={image_link} header={props.header} detail={props.detail} />
                  )}
                  {currentTab === 'activity' && <ActivityData subDevices={props.subDevices} />}
                  {currentTab === 'history' && (
                    <HistoryData
                      data={hist_plot}
                      startDate={props.startDate}
                      stopDate={props.stopDate}
                      handleStartDate={props.handleStartDate}
                      handleStopDate={props.handleStopDate}
                    />
                  )}
                </nav>
              </div>
            </div>
          )}
        </section>
        <footer className="modal-card-foot is-fullwidth" style={{ padding: '10px 20px 10px 20px' }}>
          <div
            className="column is-fullwidth"
            style={{ padding: '0', width: '100%', textAlign: 'right' }}
          >
            <button
              onClick={(e) => onCloseModal(e)}
              className="button"
              style={{
                background: '#555',
                color: '#fff',
              }}
            >
              DONE
            </button>
          </div>
        </footer>
      </div>
    </div>
  );
};

export { SmartTVControl };
